import React from 'react'

const StarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.5 9.79375L10.3625 12.125L9.3375 7.73125L12.75 4.775L8.25625 4.39375L6.5 0.25L4.74375 4.39375L0.25 4.775L3.6625 7.73125L2.6375 12.125L6.5 9.79375Z'
      fill='currentColor'
    />
  </svg>
)

export default StarIcon
